import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";
import Tour from "reactour";
import { ToastContainer } from "react-toastify";
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import Modal from "../../../components/ModalSuccessMessage";
import ErrorMessage from "../../../components/ErrorMessage";
import CreditCard from "../../../components/CreditCard/index.js";
import { ContainerButton, Legend } from "./styles";
import { openModal } from "../../../helpers/modalFunctions";
import routesCard from "../../../routes/card.routes";
import search from "../../../assets/icons/search.svg";
import colors from "../../../assets/css/colors";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import { initialClientTokenCard } from "../../../helpers/initialClientTokenCard";
import { useQuery } from "react-query"
import { getBuyersAtApi } from "../../../hooks/getBuyersAtApi";
import { maskCardNumberToShow } from "../../../utils/maskCardNumberToShow";
import { MASK } from "../../../helpers/maskContants";
import { stepsTourTokenCard } from "../../../helpers/stepsTourTokenCard";
import MsgErrorInput from "../../../components/MsgErrorInput";
import ContainerInput from "../../../components/ContainerInput";
import Button from "../../../components/Button";
import { VALIDATION } from "../../../helpers/validationFormLenght";
import { postCardToken } from "../../../hooks/postCardToken";
import { errorHandlerApi } from "../../../hooks/errorHandlerApi";

const TokenCard = () => {
    const [client, setClient] = useState(initialClientTokenCard);
    const [debouncedClientName, setDebouncedClientName] = useState("");
    const [name, setName] = useState("");
    const [cvv, setCvv] = useState("");
    const [valid, setValid] = useState("");
    const [messageError, setMessageError] = useState("Falha ao tokenizar cartão");

    const [first4Numbers, setFirst4Numbers] = useState("");
    const [last4Numbers, setLast4Numbers] = useState("");

    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

    const [searchResults, setSearchResults] = useState([]);

    const [tutorialTourIsOpen, setTutorialTourIsOpen] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    function useQueryCustom() {
        return new URLSearchParams(useLocation().search);
    }

    useQuery(["getBuyerAtApi", debouncedClientName], () => {
        if(debouncedClientName.length !== 0 ){
            getBuyersAtApi(
                login.user.branchsId, 
                debouncedClientName, 
                setSearchResults
            )
        }
    })


    const query = useQueryCustom();

    useEffect(() => {
        if(login.user.groups.cm3a1 === false){
            history.push("/admin/dashboard");
        }

        if(query.get("tutorial") !== null){
            setTutorialTourIsOpen(true)
        }
    }, []);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedClientName(client.firstName)
        }, 600);
        
        return () => {
            clearTimeout(timerId);
        }
    }, [client.firstName]);

    const formValidationWithYup = Yup.object().shape({
        client: Yup.string().required("*Obrigatório"),
        nameOnCard: Yup.string().required("*Obrigatório"),
        cardNumber: Yup.string().required("*Obrigatório").length(VALIDATION.CARD_NUMBER_LENGTH, "*Quantidade de números é inválida"),
        cardValidity: Yup.string().required("*Obrigatório").length(VALIDATION.CARD_EXPIRATION_DATE_LENGTH, "*Data inválida, tente mês/ano"),
        cvv: Yup.string().required("*Obrigatório").min(VALIDATION.CARD_CVV_MIN_LENGTH, "*CVV deve ter no mínimo 3 dígitos").max(VALIDATION.CARD_CVV_MAX_LENGTH, "*CVV deve ter no máximo 4 dígitos")
    });

    const searchForErrors = (errors: Object) => {
        if(Object.keys(errors).length !== 0){
            setErrorOnSubmit(true)
        } else {
            setErrorOnSubmit(false)
        }
    }

    const handleChangeClient = async (event: any) => {
        setClient({
            id: client.id, 
            buyerIdAdquirente: client.buyerIdAdquirente,
            firstName: event.target.value,
            lastName: client.lastName
        });
    }

    return(
        <Main>
            <ToastContainer />
            <Tour
                steps={stepsTourTokenCard}
                isOpen={tutorialTourIsOpen}
                onRequestClose={() => setTutorialTourIsOpen(false)} 
                accentColor={colors.primary}
                showNumber={false}
                showNavigation
                showNavigationNumber={false}
                showButtons
            />
            <Header title="Cartão" subTitle="Associe cartões aos seus clientes para pagamentos via cartão de crédito" subTitleWidth={240}/>
            <NavTabs tabs={routesCard}/>
            <Modal text="Tokenizado com Sucesso"/>
            
            <Formik
                initialValues={{
                    client: null,
                    nameOnCard: "",
                    cardNumber: "",
                    cardValidity: "",
                    cvv: ""
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    const { isError, block } = await postCardToken<any>(
                        values,
                        login,
                        client
                    )

                    if(isError || block.status_code === 402){
                        setErrorOnReturnApi(true);
                        errorHandlerApi(
                            block, 
                            "Ocorreu um problema, entre em contato com o suporte.",
                            setMessageError, 
                            "btnSubmit"
                        )
                    }

                    else {
                        setErrorOnReturnApi(false);
                        toastUpdate("btnSubmit","success",2000,"Sucesso" )
                        openModal("exampleModal");
                    }
                }}
            >
                {({
                    values, 
                    errors, 
                    touched, 
                    dirty, 
                    isValid, 
                    handleChange
                }) => (
                        <>
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-4" id="card-form">
                                    <Legend>Dados do cartão</Legend>
                                        <Form id="form-card">
                                        <ContainerInput>
                                                <div className="inputWithIcon">
                                                    <Field 
                                                        id="inputWithIcon"
                                                        className="inputCustom" 
                                                        name="client"
                                                        type="search"
                                                        autoComplete="off"
                                                        isError={touched.client && errors.client}
                                                        placeholder="Cliente"
                                                        value={client.firstName}
                                                        onChange={(e: any) => {
                                                            handleChangeClient(e)
                                                            values.client = e.target.value
                                                        }}
                                                        isSearchField={true}
                                                        setValue={setClient}
                                                        searchResults={searchResults}
                                                        searchType="name"
                                                        as={Input}
                                                    />
                                                    <img src={search}/>
                                                </div>
                                                
                                                <MsgErrorInput>{touched.client && errors.client && errors.nameOnCard}</MsgErrorInput>
                                            </ContainerInput>
                                            <ContainerInput>
                                                <Field 
                                                    id="nameOnCard"  
                                                    name="nameOnCard" 
                                                    className="inputCustom"
                                                    placeholder="Nome como no Cartão" 
                                                    isError={touched.nameOnCard && errors.nameOnCard}
                                                    as={Input}
                                                    onKeyUp={ () => setName(values.nameOnCard.toUpperCase()) }
                                                />
                                                
                                                <MsgErrorInput>{touched.nameOnCard && errors.nameOnCard && errors.nameOnCard}</MsgErrorInput>
                                            </ContainerInput>
                                            <ContainerInput>
                                                <Field 
                                                    name="cardNumber"
                                                    id="cardNumber" 
                                                    className="input-masked inputCustom" 
                                                    style={{borderColor: `${touched.cardNumber && errors.cardNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Número" 
                                                    mask={MASK.CARD_NUMBER}
                                                    maskChar={null}
                                                    onChange={handleChange}
                                                    onKeyUp={()=>{
                                                        const { first4Numbers, last4Numbers } = maskCardNumberToShow(values.cardNumber.trim())
                                                        
                                                        setFirst4Numbers(first4Numbers);
                                                        setLast4Numbers(last4Numbers);
                                                    }}
                                                    as={InputMask}
                                                />
                                                <MsgErrorInput>{touched.cardNumber && errors.cardNumber && errors.cardNumber}</MsgErrorInput>
                                            </ContainerInput>
                                            
                                            <ContainerInput>
                                                <Field
                                                    name="cardValidity"
                                                    id="cardValidity" 
                                                    className="input-masked inputCustom"
                                                    style={{borderColor: `${touched.cardValidity && errors.cardValidity ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Expiração mês/ano" 
                                                    mask={MASK.CARD_EXPIRATION}
                                                    maskChar={null}
                                                    onChange={handleChange}
                                                    onKeyUp={() => setValid(values.cardValidity) } 
                                                    as={InputMask}
                                                />
                                                <MsgErrorInput>{touched.cardValidity && errors.cardValidity && errors.cardValidity}</MsgErrorInput>
                                            </ContainerInput>
                                            
                                            <ContainerInput>
                                                <Field 
                                                    id="cvv" 
                                                    name="cvv" 
                                                    className="inputCustom" 
                                                    isError={touched.cvv && errors.cvv}
                                                    placeholder="CVV" 
                                                    as={Input}
                                                    onKeyUp={() => setCvv(values.cvv) }
                                                />
                                                <MsgErrorInput>{touched.cvv && errors.cvv && errors.cvv}</MsgErrorInput>
                                            </ContainerInput>
                                        </Form>
                                </div>
                                
                                <div className="col-12 col-sm-6 col-lg-4 d-flex align-items-center" >
                                    <CreditCard  name={name} cvv={cvv} valid={valid} firstNumbers={first4Numbers} lastNumbers={last4Numbers} id="credit-card"/>
                                </div>
                                
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-4">
                                    <Form id="form-button">
                                        {
                                            errorOnSubmit && client.id === ""
                                            && toastUpdate(
                                                "btnSubmit", 
                                                "warning", 
                                                3000, 
                                                "Escolha um cliente"
                                            )
                                        }
                                        
                                        { notifysFieldsForm(errors, errorOnSubmit) }
                                        
                                        <ContainerButton>
                                            {
                                                errorOnReturnApi 
                                                && <ErrorMessage>
                                                        { messageError }
                                                    </ErrorMessage> 
                                            }
                                            <Button 
                                                id="button-submit"
                                                type="submit"
                                                disabled={!(isValid && dirty)}
                                                onClick={() => {
                                                    searchForErrors(errors);
                                                    toastCreate("btnSubmit", "info", 2000, "Processando")
                                                }}
                                            >
                                                Tokenizar Cartão
                                            </Button>
                                            
                                        </ContainerButton>
                                    </Form>
                                </div>
                            </div>
                        </>
                    )}
            </Formik>
        </Main>
    )
}

export default TokenCard;